import React from 'react'
import { styled } from '../../styles/stitches.config'

const OptimiseRoutineSection = (props) => {
    const OptimiseRoutineBlock = styled('section', {
        backgroundColor: '#f8f5f1',
        padding: '120px 80px',
        h2: {
            fontFamily: '$default',
            fontSize: '36px',
            marginBottom: '48px',
        },
    });
    const RoutineContainer = styled('div', {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        '& div': {
            textAlign: 'center',
            display: 'flex',
            flexFlow: 'column wrap',
            alignItems: 'center',
        },
        h4: {
            fontFamily: '$lato',
            textTransform: 'uppercase',
            letterSpacing: '4px',
            fontSize: '14px',
            color: '#666',
        },
        h3: {
            fontFamily: '$default',
            fontSize: '24px',
            marginTop: '12px',
        },
        p: {
            fontFamily: '$default',
        },
        '@bp1': {
            textAlign: 'center',
            gridTemplateColumns: '1fr',
            gap: '80px',
        },
    });
    const RoutineContainerQualifier = styled('div', {
        display: 'grid',
        gridTemplateColumns: '3fr 1fr',
        '& .routineWords': {
            padding: '0 120px',
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            fontFamily: '$default',
            fontStyle: 'italic',
            fontSize: '20px',
        },
        '& div': {
            textAlign: 'center',
            display: 'flex',
            flexFlow: 'column wrap',
            alignItems: 'center',
        },
        h4: {
            fontFamily: '$lato',
            textTransform: 'uppercase',
            letterSpacing: '4px',
            fontSize: '14px',
            color: '#666',
        },
        h3: {
            fontFamily: '$default',
            fontSize: '24px',
            marginTop: '12px',
        },
        p: {
            fontFamily: '$default',
        },
        '@bp1': {
            textAlign: 'center',
            gridTemplateColumns: '1fr',
            display: 'none',
        },
    });
    const RoutineContainerQualifierSmall = styled('div', {
        display: 'none !important',
        '@bp1': {
            display: 'grid !important',
            // marginBottom: '48px',
        },
        '& .routineWordsSmall': {
            // padding: '0 120px',
            display: 'flex',
            flexFlow: 'column wrap',
            fontFamily: '$default',
            fontStyle: 'italic',
            fontSize: '20px',
            alignItems: 'center ',
        },
        '& .row1': {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '30px',
        },
        '& .row2': {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: '30px',
        },
        '& .row3': {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '30px',
        },
        '& div': {
            textAlign: 'center',
            display: 'flex',
            flexFlow: 'column wrap',
            alignItems: 'center',
        },
        h4: {
            fontFamily: '$lato',
            textTransform: 'uppercase',
            letterSpacing: '4px',
            fontSize: '14px',
            color: '#666',
        },
        h3: {
            fontFamily: '$default',
            fontSize: '24px',
            marginTop: '12px',
        },
        p: {
            fontFamily: '$default',
        },
    });

    return (
        <OptimiseRoutineBlock id="optimiseYourRoutine">
            <h2 style={{ textAlign: 'center' }}>Here’s how you can optimise your routine and maximise your results</h2>
            <RoutineContainer>
                <div>
                    <h4>Step 1</h4>
                    <h3>Cleanse</h3>
                    <p>&nbsp;</p>
                    <svg width="240" height="116" viewBox="0 0 240 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M102.862 17.541C102.659 18.129 102.959 18.766 103.54 18.97C103.653 19.006 103.777 19.033 103.9 19.033H118.895V28.321H115.588C113.802 28.321 112.37 29.776 112.37 31.568V39.241H109.694C107.918 39.241 106.477 40.696 106.477 42.488V48.375H101.217C99.4413 48.375 98 49.83 98 51.615V105.387C98 108.487 100.489 111 103.55 111H135.999C139.069 111 141.555 108.487 141.555 105.387V51.615C141.555 49.83 140.114 48.375 138.338 48.375H133.079V42.488C133.079 40.696 131.637 39.241 129.861 39.241H127.188V31.568C127.188 29.776 125.743 28.321 123.968 28.321H120.66V19.033H125.823C126.431 19.033 126.931 18.536 126.931 17.915V12.118C126.931 11.497 126.441 11 125.823 11H112C107.892 11 104.217 13.626 102.862 17.541Z" fill="black" />
                    </svg>
                </div>
                <div>
                    <h4>Step 2</h4>
                    <h3>Treat</h3>
                    <p>Better Days Skin Co.</p>
                    <svg width="240" height="116" viewBox="0 0 240 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M94.6875 43.5C94.105 43.5 93.6328 43.972 93.6328 44.555V49.828C93.6328 50.811 94.3051 51.637 95.2148 51.871V55.602C95.113 55.929 94.9533 56.23 94.7482 56.494C90.028 58.71 86.6725 63.351 86.2871 68.812H86.25V103.617H86.3153C86.8343 107.779 90.3848 111 94.6875 111H113.672C117.975 111 121.525 107.779 122.044 103.617H122.109V68.812H122.072C121.687 63.353 118.334 58.713 113.617 56.496C113.408 56.229 113.247 55.923 113.145 55.591V51.871C114.054 51.637 114.727 50.811 114.727 49.828V44.555C114.727 43.972 114.254 43.5 113.672 43.5H94.6875Z" fill="black" />
                        <path d="M129.492 99.398H133.008L135.74 66.616C135.785 66.069 136.242 65.648 136.791 65.648H142.233C142.781 65.648 143.238 66.069 143.284 66.616L146.016 99.398H149.531C150.114 99.398 150.586 99.871 150.586 100.453V108.891C150.586 109.473 150.114 109.945 149.531 109.945V110.473C149.531 110.764 149.295 111 149.004 111H130.02C129.728 111 129.492 110.764 129.492 110.473V109.945C128.91 109.945 128.438 109.473 128.438 108.891V100.453C128.438 99.871 128.91 99.398 129.492 99.398Z" fill="black" />
                    </svg>
                    <RoutineContainerQualifierSmall>
                        <div style={{ gridColumn: '1 -1', marginBottom: '24px', marginTop: '24px' }}>
                            <svg width="135" height="39" viewBox="0 0 135 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M67 23V0" stroke="black" strokeLinejoin="round" />
                                <path d="M15.707 23L0.707001 38L-9.91821e-05 37.2929L15.293 22H16.707H119L135 38L134.293 38.7071L118.586 23H15.707Z" fill="black" />
                            </svg>
                        </div>
                        <div className="routineWordsSmall">
                            <div className="row1">
                                <h5>exfoliate</h5>
                                <h5>brighten</h5>
                            </div>
                            <div className="row2">
                                <h5>hydrate</h5>
                                <h5>energise</h5>
                                <h5>firm</h5>
                            </div>
                            <div className="row3">
                                <h5>soothe</h5>
                                <h5>restore</h5>
                            </div>
                        </div>
                        <div />
                    </RoutineContainerQualifierSmall>
                </div>
                <div>
                    <h4>Step 3</h4>
                    <h3>Moisturise</h3>
                    <p>&nbsp;</p>
                    <svg width="240" height="116" viewBox="0 0 240 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M121.042 72.404C136.04 72.404 144.477 70.141 144.99 68.876L144.984 62.321C139.074 65.403 121.916 65.448 121.042 65.448C120.167 65.448 103.016 65.403 97.1029 62.321V68.892C97.6839 70.164 106.114 72.404 121.042 72.404ZM146.975 68.537V68.928C146.975 74.353 122.1 74.415 121.042 74.415C119.983 74.415 95.1115 74.353 95.1115 68.928V68.537C93.6817 69.192 92.9167 69.86 92.9167 70.454C92.9167 72.717 103.874 76.006 121.042 76.006C138.212 76.006 149.167 72.717 149.167 70.454C149.167 69.86 148.402 69.196 146.975 68.537ZM92.9167 73.378V105.06C92.9167 106.987 103.597 110.528 121.042 110.528C138.49 110.528 149.167 106.987 149.167 105.06V73.378C144.158 76.729 130.721 78.017 121.042 78.017C111.366 78.017 97.9259 76.729 92.9167 73.378Z" fill="black" />
                        <path d="M121.041 63.438C111.627 63.438 104.8 62.547 100.895 61.572C101.04 61.398 101.131 61.172 101.127 60.93C101.127 60.92 101.131 60.917 101.131 60.911C101.079 58.225 102.228 56.001 104.21 54.969C104.313 54.917 104.416 54.865 104.516 54.817C105.036 54.562 105.678 54.246 106.137 53.639C106.482 53.181 106.63 52.683 106.766 52.245C106.792 52.151 106.821 52.057 106.85 51.964C107.373 50.373 108.748 49.078 110.355 48.662L110.633 48.597C111.246 48.452 112.008 48.271 112.566 47.636C113.018 47.122 113.157 46.506 113.27 46.015L113.308 45.844C113.812 43.717 115.38 41.881 117.362 41C118.53 47.648 124.618 49.169 129.133 50.289C130.353 50.595 131.508 50.882 132.415 51.231C137.27 53.097 140.103 56.263 141.075 60.891C141.088 60.956 141.104 61.02 141.117 61.088C141.152 61.259 141.23 61.408 141.336 61.533C137.454 62.524 130.576 63.438 121.041 63.438Z" fill="black" />
                        <path d="M99.1493 61.065C99.1461 61.027 99.1364 60.991 99.1364 60.949C99.1202 60.204 99.188 59.487 99.3203 58.803C98.0519 59.216 97.3096 59.623 97.1191 59.962C97.3031 60.287 97.9874 60.672 99.1493 61.065ZM144.965 59.962C144.764 59.603 143.954 59.171 142.566 58.735C142.77 59.364 142.941 60.016 143.073 60.694C143.096 60.804 143.096 60.91 143.08 61.017C144.154 60.639 144.793 60.275 144.965 59.962Z" fill="black" />
                    </svg>
                </div>
                <div>
                    <h4>Step 4</h4>
                    <h3>Sunscreen</h3>
                    <p>(Daytime Only)</p>
                    <svg width="240" height="116" viewBox="0 0 240 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M143.259 16.254H97.7389L97 11H143.998L143.259 16.254ZM104.98 42.818L110.301 40.665L108.154 35.318L113.832 36.123L114.634 30.416L119.153 33.966L122.688 29.429L124.834 34.772L130.155 32.614L129.353 38.322L135.034 39.127L131.499 43.669L136.018 47.218L130.697 49.376L132.847 54.719L127.166 53.917L126.364 59.621L121.845 56.071L118.31 60.612L116.164 55.265L110.843 57.422L111.645 51.715L105.964 50.909L109.499 46.372L104.98 42.818ZM132.346 93.864L142.795 19.551H98.2031L108.652 93.864H132.346Z" fill="black" />
                        <path d="M113.004 50.716C112.024 49.413 111.381 47.857 111.173 46.186C111.073 45.38 111.073 44.545 111.192 43.702C111.311 42.87 111.533 42.083 111.842 41.348C112.491 39.796 113.531 38.474 114.831 37.49C116.138 36.495 117.705 35.845 119.383 35.644C120.17 35.548 120.983 35.552 121.812 35.67C122.636 35.786 123.423 36.008 124.155 36.32C125.696 36.974 127.014 38.021 127.994 39.321C128.974 40.624 129.617 42.183 129.825 43.851C129.925 44.656 129.925 45.492 129.806 46.338C129.687 47.166 129.464 47.954 129.156 48.693C128.506 50.245 127.467 51.563 126.171 52.547C124.875 53.535 123.327 54.184 121.663 54.389C120.857 54.489 120.029 54.489 119.186 54.37C118.362 54.255 117.575 54.032 116.843 53.717C115.302 53.067 113.984 52.016 113.004 50.716Z" fill="black" />
                        <path d="M108.904 97.161H132.093V106.399C132.093 108.935 130.036 111 127.515 111H113.483C110.962 111 108.904 108.935 108.904 106.399V97.161Z" fill="black" />
                    </svg>

                </div>
            </RoutineContainer>
            <RoutineContainerQualifier>
                <div>
                    <svg width="625" height="92" viewBox="0 0 625 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="311.5" y1="23" x2="311.5" y2="-2.18557e-08" stroke="black" strokeLinejoin="round"></line>
                        <path d="M54.7071 23L39.7071 38L39 37.2929L54.2928 22L55.7071 22L568.707 22L584.707 38L584 38.7071L568.293 23H54.7071Z" fill="black"></path>
                    </svg>
                </div>
                <div />
                <div className="routineWords">
                    <h5>exfoliate</h5>
                    <h5>brighten</h5>
                    <h5>hydrate</h5>
                    <h5>energise</h5>
                    <h5>firm</h5>
                    <h5>soothe</h5>
                    <h5>restore</h5>
                </div>
                <div />
            </RoutineContainerQualifier>
        </OptimiseRoutineBlock >
    )
}

export default OptimiseRoutineSection
